import React, { useState, useEffect } from'react';

import { useNavigate } from'react-router-dom';
import { Dropdown } from'react-bootstrap';
import classNames from'classnames';
import { useToggle } from'hooks';

import PerfilWindows from'./PerfilWindows';
import AcessesWindows from'./AccessWindows';

import useAuth, { type CurrentLoginDTO} from'global/Auth/use';
import { RelationTypeMap } from'api/Types';
import profileFallback from"assets/images/users/avatar-2.jpg";
const BASE_URL = import.meta.env.VITE_API_URL as string;

export type { CurrentLoginDTO };

export type RelationData = NonNullable<CurrentLoginDTO["relationData"]>;
export type ProfileData = RelationData["profile"];

type ProfileDropdownProps = {
    userImage?: string;
    username: string;
    userTitle?: string;
};

const translateUserTitle = (title?: string) => {
    if (!title) return'';

    const titles: Record<string, string> = {
        Admin:'Administrador',
        Administrator:'Administrador',
        User:'Usuario',
        Manager:'Gerente',
        Supervisor:'Supervisor',
        Employee:'Funcionario',
        Client:'Cliente',
        Customer:'Cliente',
        Guest:'Convidado',
        Owner:'Proprietario',
    };

    return titles[title] || title;
};

type optionMenu = {
    label: string;
    icon: string;
    onClick: () => void;
}

const ProfileDropdown = () => {

    const [isOpen, toggleDropdown] = useToggle();
    const [showPerfil, setShowPerfil] = useState(false);
    const [showAcesses, setShowAcesses] = useState(false);

    const CurrentLogin = useAuth(state => state.data);
    const superAdminView = useAuth(state => state.superAdminView);
    const setSuperAdminView = useAuth(state => state.setSuperAdminView);
    const { relationData } = CurrentLogin || {};

    const [title, setTitle] = useState<string>("Visitante");

    const Navigate = useNavigate();

    const menuItems: optionMenu[] = [
        {
            label:'Perfil',
            icon:'fa-solid fa-user',
            onClick: () => {
                setShowPerfil(true);
            },
        },
        {
            label:'Trocar de conta',
            icon:'fa-solid fa-gear',
            onClick: () => {
                setShowAcesses(true);
            },
        },
        ...(CurrentLogin?.isAdmin ? [{
            label: superAdminView ? 'Sair do modo Super Admin' : 'Modo Super Admin',
            icon:'fa-solid fa-user-shield',
            onClick: () => {
                setSuperAdminView(!superAdminView);
            },
        }] : []),
        {
            label:'Sair',
            icon:'fa-solid fa-right-from-bracket',
            onClick: () => {
                Navigate('/logout');
            },
        },
    ]

    const displayName = relationData?.profile?.fullName
        ? relationData.profile.fullName.length > 28
            ? `${relationData.profile.fullName.slice(0, 28)}...`
            : relationData.profile.fullName
        :"Usuário";

    const displayNameTitle = relationData?.profile?.fullName ||"Usuário";

    useEffect(() => {
        console.log('RelationData:', relationData);
        if(relationData){
            const relationInfo = RelationTypeMap[relationData.relationType];
            if (relationInfo) {
                setTitle(translateUserTitle(relationInfo.title));
            } else {
                setTitle("Visitante");
            }
        }else{
            setTitle("No Account");
        }
    }, [relationData]);

return (
  <>
    <style>{`
      #dropdown-profile::after {
        display: none !important;
      }
    `}</style>

    <div  className="w-100 px-3 pb-1 mt-2">
      <Dropdown
        show={isOpen}
        onToggle={toggleDropdown}
        drop="end"
        className="w-100"
      >
        <Dropdown.Toggle
          variant="link"
          id="dropdown-profile"
          onClick={toggleDropdown}
          className="d-flex align-items-center gap-2 w-100 px-2 py-2 rounded-3 text-decoration-none border-0 shadow-none bg-primary"
        >
          <img
            src={ relationData?.profile?.avatarFile?.fileUrl || profileFallback }
            className="rounded-circle flex-shrink-0"
            alt="user"
            width={34}
            height={34}
            style={{ objectFit:"cover" }}
          />

          <span className="d-flex flex-column justify-content-center text-start overflow-hidden" style={{ minWidth: 0 }}>
            <span className="fw-semibold text-white text-truncate lh-sm" title={displayNameTitle}>
              {displayName}
            </span>

            <span className="small text-white-50 text-truncate lh-sm">
              {title}
            </span>
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu
          align="start"
          className="dropdown-menu-animated profile-dropdown shadow"
        >
          <div onClick={toggleDropdown}>
            {menuItems.map((item, i) => (
              <button
                onClick={item.onClick}
                className="dropdown-item notify-item d-flex align-items-center gap-2"
                key={i +"-profile-menu"}
              >
                <i className={classNames(item.icon)}></i>
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>

    {showPerfil && relationData && (
      <PerfilWindows
        onHide={() => setShowPerfil(false)}
        title={title}
        relationData={relationData}
      />
    )}

    {showAcesses && relationData && (
      <AcessesWindows
        onHide={() => setShowAcesses(false)}
        relationData={relationData}
      />
    )}
  </>
);
};

export default ProfileDropdown;